import { isValidElement } from 'react';

type WrapBaseProps = {
  when: boolean;
  single?: boolean;
};

type WrapSingleProps = WrapBaseProps & {
  single: true;
  children: React.ReactElement;
  with: (children: React.ReactElement) => React.JSX.Element;
  fallback?: (children: React.ReactElement) => React.JSX.Element;
};

type WrapMultipleProps = WrapBaseProps & {
  single?: false | undefined;
  children: React.ReactNode;
  with: (children: React.ReactNode) => React.JSX.Element;
  fallback?: (children: React.ReactNode) => React.JSX.Element;
};

type Props = WrapSingleProps | WrapMultipleProps;

const Wrap: React.FC<Props> = ({
  with: wrapWith,
  when,
  fallback,
  children,
  single,
}) => {
  if (single && !isValidElement(children)) {
    throw new Error('Expected a single ReactElement when using single={true}');
  }

  if (single) {
    return when ? (
      wrapWith(children)
    ) : fallback ? (
      fallback(children)
    ) : (
      <>{children}</>
    );
  } else {
    return when ? (
      wrapWith(children)
    ) : fallback ? (
      fallback(children)
    ) : (
      <>{children}</>
    );
  }
};

export default Wrap;
